export class Path {
  public static readonly LOGIN = {
    GET_USER_DETAILS: "/login-web/web?",
    UPDATE_LAST_CHANGE_PASSWORD_DATE: "/login-web/password-changed-date"
  };
 
  public static readonly ACCOUNT_SETTINGS = {
    GET_LIST: "/host-app-setting/sync",
    SAVE_SETTINGS: "/host-app-setting/post"
  };
 
  public static readonly ALLOCATION = {
    VALIDATE_LEVEL_ONE: "/user-allocation/validated-allocated-quantity",
    ALLOCATE_LEVEL_ONE: "/user-allocation/allocate",
    VALIDATE_LEVEL_TWO: "/recipient-allocation/validated-allocated-quantity",
    ALLOCATE_LEVEL_TWO: "/recipient-allocation/allocate",
    GET_USER_CAMPAIGN_DISTRIB_LIST: "/user-allocation/campaign-distribution/list",
    GET_RECIPIENT_CAMPAIGN_DISTRIB_LIST: "/recipient-allocation/campaign-distribution/list",
    GET_LV1_USER_LIST: "/user-allocation/user/list",
    GET_LV2_USER_LIST: "/recipient-allocation/recipient/list",
    LV1_SERIES: "/user-allocation/user-series/list/download",
    LV2_SERIES: "/recipient-allocation/recipient-series/list/download",
    GET_LV1_COUPON_DETAIL: "/user-allocation/distribution-coupon-details",
    GET_LV2_COUPON_DETAIL: "/recipient-allocation/distribution-coupon-details",
    DOWNLOAD_TEMPLATE_LEVEL_ONE: "/user-allocation-download/task-runner",
    DOWNLOAD_TEMPLATE_LEVEL_TWO: "/recipient-allocation-download/task-runner"
  };
 
  public static readonly AREA = {
    GET_LIST: "/area/list",
    GET_DETAIL: "/area/detail?",
    INSERT: "/area/upsert",
  };

  public static readonly BRANCH = {
    GET_LIST: "/branch/list",
    GET_DETAIL: "/branch/detail?",
    INSERT: "/branch/upsert",
  };
 
  public static readonly BRAND = {
    GET_LIST: "/brand/list",
    GET_WIZARD_LIST: "/brand/wizard-list",
    GET_DETAIL: "/brand/detail?",
    INSERT: "/brand/upsert",
  };
 
  public static readonly CAMPAIGNS = {
    GET_LIST: "/campaign/list",
    GET_DETAIL: "/campaign/details?",
    INSERT: "/campaign/insert",
  };
 
  public static readonly CAMPAIGN_WIZARD = {
    GET_LIST: "/wizard-campaign/list",
    GET_STATUS: "/wizard-campaign/status-list",
    GENERATE_COUPON: "/coupon-generation/send_queue",
    CHECK_QUANTITY: "/coupon-generation/check-available-quantity",
    DOWNLOAD_COUPONS_LIST: "/wizard-campaign/download",
    GENERATE_USER_RECIPIENT_MAPPING: "/wizard-campaign/task-runner",
    GET_WEB_USER_GROUP_LIST: "/wizard-campaign/web-user-group",
    GET_RECIPIENT_GROUP_LIST: "/wizard-campaign/recipient-group",
  };
 
  public static readonly CATEGORY = {
    GET_LIST: "/category/list",
    GET_WIZARD_LIST: "/category/wizard-list",
    GET_DETAIL: "/category/detail?",
    INSERT: "/category/upsert",
  };
 
  public static readonly CHAIN = {
    GET_LIST: "/chain/list",
    GET_HANDLING_FEES: "/handling-fee/list",
    INSERT: "/chain/upsert",
    INSERT_HANDLING_FEE: "/handling-fee/upsert",
  };
 
  public static readonly CHAIN_TYPE = {
    GET_LIST: "/chain_type/list",
    GET_DETAIL: "/chain_type/detail?",
    INSERT: "/chain_type/upsert",
  };
 
  public static readonly CITY = {
    GET_LIST: "/location/list/city",
    GET_LIST_FOR_DROPDOWN: "/branch/city/list"
  };
 
  public static readonly COMPANY = {
    GET_LIST: "/company/list/web",
    GET_LIST_WEB_USER_COMPANY_MAPPING: "/company/list_web_user_company_mapping/web",
    GET_DETAIL: "/company/detail?",
    INSERT: "/company/upsert/web",
    GET_INDUSTRY: "/company/upsert/web",
  };
 
  public static readonly COUNTRY = {
    GET_LIST: "/location/list/country"
  };
 
  public static readonly DEVICE = {
    GET_LIST: "/device/list",
    GET_DETAIL: "/device/detail?",
    GET_LOCATION: "/device/location/list",
    INSERT: "/device/upsert",
  };
 
  public static readonly DISTRIBUTION = {
    GET_LIST: "/distribution/list",
    GET_DETAIL: "/distribution/details",
    DISTRIBUTION_PROMO: "/distribution_promo/list",
    DISTRIBUTION_PROMO_DETAIL: "/distribution-promo-detail/list",
    DISTRIBUTION_PROMO_DETAIL_MECHANIC: "/distribution-promo-detail-mechanic/list",
    DISTRIBUTION_PROMO_DETAIL_SKU: "/distribution-promo-detail-sku/list",
    POST_PROMO_CONDITION: "/promo_condition/post",
    INSERT: "/distribution/insert",
    DELETE: "/distribution/delete",
  };
 
  public static readonly DISTRICT = {
    GET_LIST: "/district/list",
    GET_DETAIL: "/district/detail?",
    INSERT: "/district/upsert",
  };

  public static readonly DOWNLOAD_MANAGER = {
    GET_LIST: "/download_manager/get",
    POST: "/download_manager/post",
    GET_REPORT_QUEUE_LIST: "/download_manager/report_queue_list",
    CANCEL: "download_manager/cancel"
  };
 
  public static readonly GROUP = {
    GET_LIST: "/group/list",
    GET_GRP_WEB_USER: "/group/list_users",
    GET_GRP_RECIPIENT: "/group/list_recipient",
    UPSERT_USER_GROUP_MAPPING: "/group/upsert-user",
    UPSERT_RECIPIENT_GROUP_MAPPING: "/group/upsert-recipient",
    GET_LIST_USER: "/group-filter/user/list",
    GET_LIST_RECIPIENT: "/group-filter/recipient/list",
    GET_LIST_USER_RECIPIENT: "/group-filter/user-recipient/list",
    GET_ISLAND_GROUP: "/location/list/island_group",
    GET_DISTRICT: "/location/list/district",
    GET_GROUP_TYPE: "/group_type/list",
    GET_DETAIL: "/group/detail?",
    INSERT: "/group/upsert",
  };
 
  public static readonly INDUSTRY = {
    GET_LIST: "/company/list_industry/web"
  };
 
  public static readonly ITEM = {
    GET_LIST: "/sku/list",
    GET_DETAIL: "/sku/detail?",
    INSERT: "/sku/upsert",
  };
 
  public static readonly SETTLEMENT = {
    REDEMPTION_FOR_SETTLEMENT: "/settlement-web/get",
    ADD_NEW_SETTLEMENT: "/settlement-web/post"
  }

  public static readonly RECEIVING = {
    GET_LV1_LIST: "/user-receiving/list",
    RECEIVE_LV1: "/user-receiving/insert",
    GET_LV2_LIST: "/recipient-receiving/list",
    RECEIVE_LV2: "/recipient-receiving/insert",
    RECEIVE_LV2_ECS: "/recipient-receiving-ecs/insert"
  };
 
  public static readonly RECIPIENT = {
    GET_LIST: "/recipient/list",
    GET_DETAIL: "/recipient/detail?",
    INSERT: "/recipient/upsert",
    GET_RECIPIENT_TYPE_LIST: "/recipient/types",
    WEB_USER_FILTER: "/recipient/web-user-filter"
  };

  public static readonly RECIPIENT_GENERATE_QR = {
    BULK_DOWNLOAD: "recipient-generate-qr/task-runner"
  };
 
  public static readonly PATIENT_GENERATE_QR = {
    BULK_DOWNLOAD: "patient-generate-qr/task-runner"
  };

  public static readonly REGION = {
    GET_LIST: "/location/list/region"
  };
 
  public static readonly ROLE = {
    GET_LIST: "/role/list",
    GET_DETAIL: "/role/detail?",
    INSERT: "/role/upsert",
  };
 
  public static readonly PROVINCE = {
    GET_LIST: "/location/list/province"
  };
 
  public static readonly PRICELIST_DOWNLOAD = {
    GET_LIST: "/sku-override-price/list"
  };

  public static readonly COUPON = {
    GET_LIST: "/coupon/list"
  }
 
  public static readonly WEB_USER = {
    GET_LIST: "/web-user/list",
    GET_DETAIL: "/user/detail?",
    INSERT: "/web-user/upsert",
  };
 
  public static readonly WURM = {
    GET_LIST: "/web-user-recipient-mapping/list",
    GET_DETAIL: "/web-user-recipient-mapping/detail?",
    INSERT: "/web-user-recipient-mapping/upsert",
  };
 
  public static readonly FILE_STATUS = {
    USER_ALLOCATION_UPLOAD: "/user-allocation-upload/task-runner",
    RECIPIENT_ALLOCATION_UPLOAD: "/recipient-allocation-upload/task-runner",
  };

  public static readonly UPLOAD = {
    GENERIC_DOWNLOAD_LIST: "/download_uploaded_file/list",
    DOWNLOAD_FILE: "/download_s3_file?",
  };
 
  public static readonly DOWNLOAD = {
    DOWNLOAD_WEB_USER_MAINTENACE: "/web-user/download",
    DOWNLOAD_WEB_USER_RECIPIENT_MAPPING_MAINTENACE: "/web-user-recipient-mapping/download",
    DOWNLOAD_COMPANY_MAINTENACE: "/company/download",
    DOWNLOAD_CHAIN_MAINTENACE: "/chain/download",
    DOWNLOAD_BRANCH_MAINTENACE: "/branch/download",
    DOWNLOAD_DEVICE_MAINTENACE: "/device/download",
    DOWNLOAD_CAMPAIGN_MAINTENACE: "/campaign/download",
    DOWNLOAD_CATEGORY_MAINTENACE: "/category/download",
    DOWNLOAD_BRAND_MAINTENACE: "/brand/download",
    DOWNLOAD_ITEM_MAINTENACE: "/item/download",
    DOWNLOAD_GROUP_MAINTENACE_MASTER: "/group/list/download",
    DOWNLOAD_GROUP_MAINTENACE_MAPPING: "/group/mapping/download",
    DOWNLOAD_RECIPIENT_MAINTENACE: "/recipient/download",
    DOWNLOAD_ROLE_MAINTENACE: "/role/download",
    DOWNLOAD_AREA_MAINTENACE: "/area/download",
    DOWNLOAD_DISTRICT_MAINTENACE: "/district/download",
    DOWNLOAD_RECIPIENT_QR: "/recipient/generate_qr",
    DOWNLOAD_PRICELIST_MAINTENANCE: "/pricelist/download"
  };
 
  public static readonly UPLOAD_MAINTENANCE = {
    POST_FILE: "/host-files/post",
  };
  
  public static readonly SECURITY_MATRIX = {
    GET_LIST: "/security/list",
    INSERT: "/security/upsert"
  };
 
  // REPORT URLS
  public static readonly DETAILED_SETTLEMENT_REPORT = {
    GENERATE: '/detailed-settlement-report/task-runner',
    CHAIN_FILTER: '/detailed-settlement-report/chain-filter',
    ISLAND_GROUP_FILTER: '/detailed-settlement-report/island-group-filter',
    REGION_FILTER: '/detailed-settlement-report/region-filter',
    PROVINCE_FILTER: '/detailed-settlement-report/province-filter',
    CITY_FILTER: '/detailed-settlement-report/city-filter',
    CAMPAIGN_FILTER: '/detailed-settlement-report/campaign-filter',
    CATEGORY_FILTER: '/detailed-settlement-report/category-filter',
    BRAND_FILTER: '/detailed-settlement-report/brand-filter',
    SKU_FILTER: '/detailed-settlement-report/sku-filter'
  }

  public static readonly POSTED_TRANSACTION_REPORT = {
    GENERATE: '/posted-transaction-report/task-runner',
    CAMPAIGN_FILTER: '/posted-transaction-report/campaign-filter',
    CHAIN_FILTER: '/posted-transaction-report/chain-filter',
    BRANCH_FILTER: '/posted-transaction-report/branch-filter',
  }
  
  public static readonly PAYMENT_SUMMARY_REPORT = {
    FILTER: '/reports-filter/settlement',
    GENERATE: '/download_manager_ecs/post'
  }
 
  public static readonly SUMMARY_BY_TERRITORY_REPORT = {
    GET_LIST: '/web-reports/territory-summary/list',
    FILTER: '/reports-filter/allocation',
    GENERATE: '/download_manager_ecs/post'
  }
 
  public static readonly QUANTITY_PURCHASE_REPORT = {
    GET_LIST: '/web-reports/quantity-purchased-by-doctor/list',
    FILTER: '/reports-filter/redemption',
    GENERATE:'/download_manager_ecs/post'
  }
 
  public static readonly  NEW_CUSTOMER_COUNT_REPORT = {
    GET_LIST: '/web-reports/new-patient-count-by-doctor/list',
    FILTER: '/reports-filter/patient-count',
    GENERATE:'/download_manager_ecs/post'
  }
 
  public static readonly  USAGE_RATE_REPORT = {
    GET_LIST: '/web-reports/usage-rate-summary/list',
    FILTER: '/reports-filter/usage-rate',
    GENERATE:'/download_manager_ecs/post'
  }
 
  public static readonly  RUNNING_BALANCE_REPORT = {
    GET_LIST: '/web-reports/allocation-and-receiving-running-balance/list',
    FILTER: '/reports-filter/user_recipient',
    GENERATE:'/download_manager_ecs/post'
  }

  public static readonly PATIENT_REGISTRATION = {
    GET: '/patient',
    POST: '/patient',
    ADD_COUPON: '/patient_coupon',
    LIST_COUPONS: '/patient_coupon',
    CHECK_MD: '/patient/check-md',
    GET_TERMS_CONDITIONS: '/termsandconditions',
    CHECK_SCHEMA: '/patient/check-schema',
    GET_QR: '/patient/get_code',
    DOWNLOAD_QR: '/patient/print_code',
    LIST_CAMPAIGNS: '/patient_campaign',
    GENERATE_COUPON: '/patient/generate_coupon',
    GET_QRS: '/patient/get_codes',
    REGION_DROPDOWN: '/patient/region_dropdown',
    PROVINCE_DROPDOWN: '/patient/province_dropdown',
    MUNICIPALITY_DROPDOWN: '/patient/city_dropdown',
    BARANGAY_DROPDOWN: '/patient/barangay_dropdown',
    VALIDATE_ADDRESS: '/patient/validate_address',
    DELETE_ACCOUNT: '/patient/opt_out',
    FB_GET_DETAILS: '/fb-customer/get-details'
  }

  public static readonly CUSTOMER_REGISTRATION = {
    GET_CAMPAIGN_URL: '/customer/campaign/get-url'
  }

  public static readonly CONSENT = {
    LIST: '/consent/list'
  }

  public static readonly OTP = {
    REQUEST: '/otp/request',
    VERIFY: '/otp/validate'
  }

  public static readonly POSTED_TXN_REPORT = {
    GET_LIST: '/report/list',
    GET_CHAINS_FILTER: '/report/chain',
    GET_BRANCHES_FILTER: '/report/branch',
    // GENERATE: '/report/download',
    GENERATE: '/download_manager_ecs/post',
  }

  public static readonly PATIENT_REGISTRATION_DETAILS_REPORT = {
    CAMPAIGN_FILTER: '/report-patient-reg-details/campaign-filter',
    GENERATE:'/report-patient-reg-details/task-runner'
  }

  public static readonly CUSTOMER_FIRST_PURCHASE_REPORT = {
    CAMPAIGN_FILTER: '/customer-first-purchase-report/campaign-filter',
    GROUP_FILTER: '/customer-first-purchase-report/group-filter',
    WEB_USER_FILTER: '/customer-first-purchase-report/web-user-filter',
    GENERATE:'/customer-first-purchase-report/task-runner'
  }

  public static readonly CUSTOMER_TRANSACTIONS_REPORT = {
    CAMPAIGN_FILTER: '/customer-transactions-report/campaign-filter',
    GROUP_FILTER: '/customer-transactions-report/group-filter',
    WEB_USER_FILTER: '/customer-transactions-report/web-user-filter',
    GENERATE:'/customer-transactions-report/task-runner'
  }

  public static readonly CUSTOMER_REGISTRATION_AND_ACTIVITY_REPORT = {
    CAMPAIGN_FILTER: '/report-customer-reg-act/campaign-filter',
    GROUP_FILTER: '/report-customer-reg-act/group-filter',
    WEB_USER_FILTER: '/report-customer-reg-act/web-user-filter',
    GENERATE:'/report-customer-reg-act/task-runner'
  }

  public static readonly CAMPAIGN_QR_DOWNLOAD = {
    CAMPAIGN_FILTER: '/campaign-qr-download/campaign-filter',
    GROUP_FILTER: '/campaign-qr-download/group-filter',
    WEB_USER_FILTER: '/campaign-qr-download/web-user-filter',
    RECIPIENT_FILTER: '/campaign-qr-download/recipient-filter',
    LIST: '/campaign-qr-download/list',
    STATUS_LIST: '/campaign-qr-download/status-list'
  }

  public static readonly MONTHLY_OTP_TRANSACTION_REPORT = {
    GENERATE: '/report-monthly-otp-transaction/task-runner'
  }

  public static readonly PRICELIST = {
    GET_LIST: "/pricelist/template",
    GET_DETAIL: "/sku/detail?",
    INSERT: "/pricelist/insert_template",
    GET_PRICELIST_ITEM_PRICES: "/pricelist/template_items", 
    GET_PRICELIST_MAPPED_STORES: "/pricelist/branch_list",
    APPLY_TEMPLATE: "/pricelist/apply_template",
    ADD_TEMPLATE_MAP: "/pricelist/insert_template_map",
    GET_UPLOAD_HISTORY: "/pricelist/history",
  };

  public static readonly CAMPAIGN_GENERATE_MASTERLIST = {
    DOWNLOAD: "campaign-generate-masterlist/task-runner"
  }
  
  public static readonly WEB_MODULE = {
    LIST: '/web-module/list'
  }

  public static readonly CAMPAIGN_ONBOARDING_AUTOMATION = {
    GET_LIST: "/campaign-onboarding-automation/batches",
    RETRY_BATCH_STEP: "/campaign-onboarding-automation/batches/retry",
    DOWNLOAD_TEMPLATE: "/campaign-onboarding-automation/download_template",
  };

};

